// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"Jaa-z","disabled":"Kaa-z","label":"Laa-z"};